import z from "zod";
import {
  booleanOperatorSchema,
  numberOperatorSchema,
  stringOperatorSchema,
} from "../operations/operation-filter";

export const filterReferralRewardRuleSchema = z.object({
  quotas: numberOperatorSchema.optional(),
  amount: numberOperatorSchema.optional(),
  type: stringOperatorSchema.optional(),
  is_active: booleanOperatorSchema.optional(),
});

export type FilterReferralRewardRuleType = z.infer<typeof filterReferralRewardRuleSchema>;
